import React from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
  theme => ({
    root: {},
    swatch: {
      width: theme.spacing(6),
      height: theme.spacing(3),
      background: theme.colors.tableBackground,
      borderRadius: 4,
      border: theme.constants.tableBorder,
    },
    color: {
      width: '100%',
      height: '100%',
      borderRadius: 3,
      backgroundColor: (props: ColorSwatchProps) => props.color,
    },
    noColor: {
      width: '100%',
      height: '100%',
      borderRadius: 3,
      background:
        'linear-gradient(340deg, rgba(223,223,223,1) 46%, rgba(228,0,0,1) 50%, rgba(223,223,223,1) 54%)',
    },
    toggleIcon: {
      color: theme.colors.sideText,
    },
    checkbox: {
      textAlign: 'center',
    },
  }),
  { name: 'ColorSwatch' },
)

interface ColorSwatchProps {
  readonly color: string
  readonly noColorValueEnabled?: boolean
}

const ColorSwatch = (props: ColorSwatchProps) => {
  const { color, noColorValueEnabled } = props
  const classes = useStyles(props)

  return (
    <Grid
      container
      item
      alignItems="center"
      className={classes.swatch}
      wrap="nowrap"
    >
      <Grid
        item
        className={
          !color.length && noColorValueEnabled ? classes.noColor : classes.color
        }
      />
    </Grid>
  )
}

export default ColorSwatch
